import { listTasks, retryTask, cancelTask, deleteTask } from '@/api/task'

let pollTimer = null
const ACTIVE = new Set(['queued', 'processing'])

const state = {
  list: [],
  centerVisible: false,
  typeFilter: 'all', // all | document-download | scan-pdf-batch | review-question-generation
  loading: false
}

const getters = {
  allTasks: (s) => s.list,
  filteredTasks: (s) => s.typeFilter === 'all' ? s.list : s.list.filter(t => t.type === s.typeFilter),
  activeCount: (s) => s.list.filter(t => ACTIVE.has(t.status)).length
}

const mutations = {
  SET_LIST(s, list) { s.list = list },
  SET_VISIBLE(s, v) { s.centerVisible = v },
  SET_TYPE_FILTER(s, t) { s.typeFilter = t },
  SET_LOADING(s, v) { s.loading = v }
}

const actions = {
  async fetchTasks({ commit }) {
    commit('SET_LOADING', true)
    try {
      const res = await listTasks({ pageSize: 50 })
      const items = res?.data?.items || []
      commit('SET_LIST', items.map(normalize))
    } finally {
      commit('SET_LOADING', false)
    }
  },
  openCenter({ commit, dispatch }) {
    commit('SET_VISIBLE', true)
    dispatch('fetchTasks')
    dispatch('startPolling')
  },
  closeCenter({ commit }) { commit('SET_VISIBLE', false) },
  setTypeFilter({ commit }, t) { commit('SET_TYPE_FILTER', t) },
  startPolling({ dispatch, state }) {
    if (pollTimer) return
    const run = async () => {
      await dispatch('fetchTasks')
      const hasActive = state.list.some(t => ACTIVE.has(t.status))
      if (!hasActive && !state.centerVisible) dispatch('stopPolling')
    }
    pollTimer = setInterval(run, 2500)
  },
  stopPolling() { if (pollTimer) { clearInterval(pollTimer); pollTimer = null } },
  async retry({ dispatch }, id) { await retryTask(id); await dispatch('fetchTasks'); dispatch('startPolling') },
  async cancel({ dispatch }, id) { await cancelTask(id); await dispatch('fetchTasks') },
  async remove({ dispatch }, id) { await deleteTask(id); await dispatch('fetchTasks') }
}

function normalize(t) {
  return {
    id: String(t._id),
    type: t.type,
    status: t.status,
    title: t.title || '任务',
    percent: t.progress?.percent || 0,
    message: t.progress?.message || '',
    result: t.result || null,
    error: t.error || '',
    refId: t.refId ? String(t.refId) : null,
    updatedAt: t.updatedAt
  }
}

export default { namespaced: true, state, getters, mutations, actions }
